import interfaceAjax from '@/libs/InterfaceAjax';

export default {

    all(data) {
        if(data.equipment && data.equipment.plateNo == ''){
            data.equipment.plateNo = null;
        }
        return interfaceAjax({
            url: '/admin/terminal/all',
            data:data
        });
    },
    onlineAll(data) {
        if(data.plateNo == ''){
            data.plateNo = null;
        }
        return interfaceAjax({
            url: '/admin/equip/onlineAll',
            timeout: 60000,
            data:data
        });
    }
}
